import { BackButton } from '@twistopayments/design-system/components/atoms/back-button'
import { useAtom } from 'jotai'
import { useRouter } from 'next/router'

import { useFlowBackOverride, useGetFlowData } from '@twisto/flow-views'
import {
  submittingFlowFormAtom,
  useGoBack,
} from '@twisto/flow-views/components'

import * as styles from './flow-app-bar.styles'

type Props = {
  source?: 'header' | 'container'
}
export const FlowGoBackButton = ({ source }: Props) => {
  const router = useRouter()
  const sessionId = router.query.sessionId as string
  const goBackInFlow = useGoBack(sessionId)
  const { flow } = useGetFlowData(sessionId)
  const handleBackButton = () => goBackInFlow()
  const [submitting] = useAtom(submittingFlowFormAtom)
  const { backOverride } = useFlowBackOverride()

  if (backOverride) {
    return (
      <BackButton
        css={source === 'container' && styles.goBackButton}
        data-testid="session-go-back"
        disabled={submitting}
        onClick={() => backOverride.goBack()}
      />
    )
  }

  if (!flow?.canGoBack) {
    return null
  }

  return (
    <BackButton
      css={source === 'container' && styles.goBackButton}
      data-testid="session-go-back"
      disabled={submitting}
      onClick={handleBackButton}
    />
  )
}
